// client/marks/link/linkConfig.ts
import "@adornis/chemistry/elements/components/x-icon";
import { XDialog } from "@adornis/dialog/x-dialog.js";
import { NodeSelection } from "prosemirror-state";
import { LINK_KEY, LINK_SCHEMA } from "../../../schema/marks/link.js";
import { MenuItemGroup } from "../../types.js";
import { linkPlugin } from "./LinkMarkView.js";
import { LinkMarkEditorDialog } from "./link-mark-editor-dialog.js";
var link = () => ({
  mark: {
    name: LINK_KEY,
    schema: LINK_SCHEMA()
  },
  menuItems: [
    {
      group: MenuItemGroup.TEXT_STYLE,
      label: "Link",
      icon: "add_link",
      shouldVisualize: (view) => {
        const { state } = view;
        const { from, to } = state.selection;
        const linkMark = state.schema.marks[LINK_KEY];
        if (!linkMark)
          return false;
        return !state.selection.empty && !(state.selection instanceof NodeSelection) && !state.doc.rangeHasMark(from, to, linkMark);
      },
      run: async (view) => {
        const { state } = view;
        const linkMark = state.schema.marks[LINK_KEY];
        if (!linkMark)
          return false;
        await LinkMarkEditorDialog.insertLink({
          href: "",
          from: state.selection.from,
          to: state.selection.to,
          target: "_self",
          view
        });
      }
    },
    {
      group: MenuItemGroup.TEXT_STYLE,
      label: "Link l\xF6schen",
      icon: "link_off",
      shouldVisualize: (view) => {
        const { state } = view;
        const linkMark = state.schema.marks[LINK_KEY];
        if (!linkMark)
          return false;
        const { from, empty } = state.selection;
        if (empty) {
          return !!linkMark.isInSet(state.storedMarks || state.doc.resolve(from).marks());
        } else {
          const { from: from2, to } = state.selection;
          return !!state.doc.rangeHasMark(from2, to, linkMark);
        }
      },
      run: async (view) => {
        return removeLink(view);
      }
    }
  ],
  plugins: (schema) => [linkPlugin]
});
async function removeLink(view) {
  if (!await XDialog.confirm("Wollen Sie diesen Link wirklich entfernen?"))
    return;
  const { state, dispatch } = view;
  const { from, to, empty } = state.selection;
  const linkMark = state.schema.marks[LINK_KEY];
  if (!linkMark)
    return false;
  if (empty) {
    const $pos = state.doc.resolve(from);
    const isInSet = linkMark.isInSet($pos.marks());
    if (isInSet) {
      const linkStart = $pos.nodeBefore ? from - $pos.nodeBefore.nodeSize : from;
      const linkEnd = $pos.nodeAfter ? from + $pos.nodeAfter.nodeSize : from;
      dispatch(state.tr.removeMark(linkStart, linkEnd, linkMark));
    }
  } else {
    dispatch(state.tr.removeMark(from, to, linkMark));
  }
}
export {
  link,
  removeLink
};
